import useStore from '../stores/store';
import { useHotkeys, isHotkeyPressed } from 'react-hotkeys-hook';
import usePersistStore from '../stores/persistStore';
import React, { useEffect, useState } from 'react';
import layoutStore from '../stores/layoutStore';
import { scrollToGroupContainer } from './Groups';
import { clearSelectionAction } from '../stores/actions/selectActions';
import useSelectStore from '../stores/selectStore';
import { createTabGroup } from '../../platformFiles/browserAPI';
import useCustomToast from './ToastProvider';

const DesktopShortcutProvider = () => {
    const createGroup = () => {
        useStore.getState().addGroup();
    };
    const setWorkspaceZoom = layoutStore((state) => state.setWorkspaceZoom);
    const hoverSide = layoutStore((state) => state.hoverSide);
    const workspaceZoom = layoutStore((state) => state.workspaceZoom);
    const setShowSearchModal = layoutStore((state) => state.setShowSearchModal);
    const showSearchModal = layoutStore((state) => state.showSearchModal);
    const showBinDrawer = layoutStore((state) => state.showBinDrawer);
    const setShowBinDrawer = layoutStore((state) => state.setShowBinDrawer);
    const selectedIds = useSelectStore((state) => state.selectedIds);
    const shortcutCreateNewGroup = usePersistStore(
        (state) => state.shortcutCreateNewGroup
    );
    const shortcutOpenWsGrid = usePersistStore(
        (state) => state.shortcutOpenWsGrid
    );
    const shortcutOpenBin = usePersistStore((state) => state.shortcutOpenBin);
    const shortcutSearch = usePersistStore((state) => state.shortcutSearch);

    const toggleSearch = () => {
        setShowSearchModal(!showSearchModal);
        setShowBinDrawer(false);
    };

    const toggleBin = () => {
        setShowBinDrawer(!showBinDrawer);
        setShowSearchModal(false);
    };

    const clearSel = () => {
        useSelectStore.getState().clearSelection();
    };

    const toggleWorkspaceZoom = debounce(() => {
        if (workspaceZoom === 'zoomed-out') {
            setWorkspaceZoom('zoomed-in');
        } else {
            setWorkspaceZoom('zoomed-out');
        }
    }, 200);

    const showToast = useCustomToast();

    const createTabGroupFromSel = () => {
        let numberIds = [];
        selectedIds.forEach((id) => {
            numberIds.push(Number(id));
        });
        createTabGroup(numberIds);
        clearSel();
        showToast({
            title:
                `${numberIds.length} ` +
                (numberIds.length === 1 ? 'tab grouped' : 'tabs grouped'),
            subtitle: 'Group created from selected tabs.',
            type: 'success'
        });
    };

    const shortcutOptions = {
        //enabled: true,
        //enableOnFormTags: false,
        //enableOnContentEditable: false,
        //combinationKey: '+',
        //splitKey: ',',
        //scopes: '*',
        //keyup: undefined,
        //keydown: true,
        preventDefault: true
        //description: undefined,
        //document: undefined,
        //ignoreModifiers: false,
    };

    useHotkeys(
        shortcutCreateNewGroup ? shortcutCreateNewGroup : 'mod+g',
        () => {
            if (hoverSide && selectedIds.length) {
                createTabGroupFromSel();
            } else {
                createGroup();
                scrollToGroupContainer('end');
            }
        },
        shortcutOptions,
        [shortcutCreateNewGroup, hoverSide, selectedIds]
    );

    useHotkeys(
        shortcutSearch ? shortcutSearch : 'mod+k',
        () => {
            toggleSearch();
        },
        shortcutOptions,
        [showSearchModal, shortcutSearch]
    );

    useHotkeys(
        shortcutOpenBin ? shortcutOpenBin : 'mod+z',
        () => {
            toggleBin();
        },
        shortcutOptions,
        [showBinDrawer, shortcutOpenBin]
    );

    useHotkeys(
        shortcutOpenWsGrid ? shortcutOpenWsGrid : 'space',
        () => {
            toggleWorkspaceZoom();
        },
        shortcutOptions,
        [workspaceZoom, shortcutOpenWsGrid]
    );

    useHotkeys(
        'esc',
        () => {
            clearSel();
            if (workspaceZoom === 'zoomed-out') {
                setWorkspaceZoom('zoomed-in');
            }
        },
        shortcutOptions,
        [selectedIds, workspaceZoom]
    );

    return <></>;
};

export default DesktopShortcutProvider;

function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
}
